export default "__VITE_ASSET__77443a08__"